// extracted by mini-css-extract-plugin
export default {"bigText":"bigText__RtpmP","uppercase":"uppercase__TT-Qs"};